import { render, staticRenderFns } from "./WidgetNivelVendedor.vue?vue&type=template&id=523dfe7c&scoped=true"
import script from "./WidgetNivelVendedor.vue?vue&type=script&lang=ts"
export * from "./WidgetNivelVendedor.vue?vue&type=script&lang=ts"
import style0 from "./WidgetNivelVendedor.vue?vue&type=style&index=0&id=523dfe7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523dfe7c",
  null
  
)

export default component.exports